import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';

export default function RegistroDemoModal({ onClose }) {
  const navigate = useNavigate();
  const { setSesionDirecta } = useAuth(); // ver nota abajo
  const [form, setForm] = useState({
    nombre: '',
    email: '',
    telefono: '',
    password: '',
    confirmar: '',
  });
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');

  const setCampo = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }
    if (form.password !== form.confirmar) {
      setError('Las contraseñas no coinciden');
      return;
    }

    setCargando(true);
    try {
      const { data } = await api.post('/demo/registro', {
        nombre: form.nombre.trim(),
        email: form.email.trim().toLowerCase(),
        telefono: form.telefono.trim() || null,
        password: form.password,
      });

      // Auto-login
      if (setSesionDirecta) {
        setSesionDirecta(data.token, data.usuario);
      } else {
        // Fallback: guardar directo en localStorage
        localStorage.setItem('token', data.token);
        localStorage.setItem('usuario', JSON.stringify(data.usuario));
      }

      // Guardar licencia para que el layout la muestre
      localStorage.setItem('licencia', JSON.stringify(data.licencia || null));

      navigate('/', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Error al crear la cuenta demo');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
      style={{
        backgroundColor: 'rgba(15, 23, 42, 0.7)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
      }}
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-lg max-h-[90vh] overflow-hidden flex flex-col"
        style={{
          border: '2px solid #0D47A1',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          className="px-6 py-4 text-white flex items-center justify-between"
          style={{
            background: 'linear-gradient(to right, #0D47A1, #1565C0)',
          }}
        >
          <div>
            <h2 className="text-base font-bold">Crea tu cuenta de prueba</h2>
            <p className="text-xs" style={{ color: '#BBDEFB' }}>
              Sin tarjeta de crédito
            </p>
          </div>
          <button
            onClick={onClose}
            className="rounded-full w-8 h-8 flex items-center justify-center transition hover:bg-white/10 text-sm"
            style={{
              color: 'rgba(255,255,255,0.9)',
              border: '1px solid rgba(255,255,255,0.3)',
            }}
            aria-label="Cerrar"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <form onSubmit={submit} className="flex-1 overflow-y-auto p-6 space-y-4">

          {/* Beneficios */}
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
            <div className="text-xs font-bold text-blue-900 mb-2">
              Tu prueba incluye:
            </div>
            <div className="grid grid-cols-3 gap-2 text-center">
              <div className="bg-white rounded-lg py-2 px-1">
                <div className="text-xl">📅</div>
                <div className="text-[10px] text-slate-600 mt-1">7 días</div>
                <div className="text-[10px] font-bold text-blue-800">gratis</div>
              </div>
              <div className="bg-white rounded-lg py-2 px-1">
                <div className="text-xl">📱</div>
                <div className="text-[10px] text-slate-600 mt-1">2 dispositivos</div>
                <div className="text-[10px] font-bold text-blue-800">activos</div>
              </div>
              <div className="bg-white rounded-lg py-2 px-1">
                <div className="text-xl">🏞️</div>
                <div className="text-[10px] text-slate-600 mt-1">3 piscinas</div>
                <div className="text-[10px] font-bold text-blue-800">incluidas</div>
              </div>
            </div>
          </div>

          {/* Nombre */}
          <label className="block">
            <span className="text-xs font-medium text-slate-700">Nombre completo *</span>
            <input
              type="text"
              value={form.nombre}
              onChange={(e) => setCampo('nombre', e.target.value)}
              className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-white text-sm"
              placeholder="Ej: Juan Pérez"
              required
              autoFocus
            />
          </label>

          {/* Email */}
          <label className="block">
            <span className="text-xs font-medium text-slate-700">Correo electrónico *</span>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setCampo('email', e.target.value)}
              className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-white text-sm"
              placeholder="tu@email.com"
              required
            />
          </label>

          {/* Teléfono */}
          <label className="block">
            <span className="text-xs font-medium text-slate-700">Teléfono</span>
            <input
              type="tel"
              value={form.telefono}
              onChange={(e) => setCampo('telefono', e.target.value)}
              className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-white text-sm"
              placeholder="Ej: 0999999999"
            />
          </label>

          {/* Passwords */}
          <div className="grid grid-cols-2 gap-3">
            <label className="block">
              <span className="text-xs font-medium text-slate-700">Contraseña *</span>
              <input
                type="password"
                value={form.password}
                onChange={(e) => setCampo('password', e.target.value)}
                className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-white text-sm"
                placeholder="Mín 6 caracteres"
                required
                minLength={6}
              />
            </label>
            <label className="block">
              <span className="text-xs font-medium text-slate-700">Confirmar *</span>
              <input
                type="password"
                value={form.confirmar}
                onChange={(e) => setCampo('confirmar', e.target.value)}
                className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-white text-sm"
                placeholder="Repite"
                required
                minLength={6}
              />
            </label>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm p-3 rounded-lg">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={cargando}
            className="w-full py-3 bg-primary text-white rounded-xl hover:bg-blue-800 disabled:opacity-50 font-semibold"
          >
            {cargando ? 'Creando cuenta...' : '✨ Crear cuenta gratis'}
          </button>

          <p className="text-[11px] text-center text-slate-500">
            Al registrarte aceptas los{' '}
            <span className="text-primary underline cursor-pointer">Términos</span>{' '}
            y la{' '}
            <span className="text-primary underline cursor-pointer">Política de Privacidad</span>
          </p>
        </form>
      </div>
    </div>
  );
}